const transformData = [
    {
        name: 'Family & friends',
        value: 'Item 1',
        keyQuestion: 'question19', 
    },
    {
        name: 'Business Angels',
        value: 'Item 2',
        keyQuestion: 'question24',
    },
    {
        name: 'Crowdfunding',
        value: 'Item 3',
        keyQuestion: 'question29',
    },
    {
        name: 'Incubators and Accelerators',
        value: 'Item 4',
        keyQuestion: 'question35',
    },
    {
        name: 'NGO’s loans',
        value: 'Item 5',
        keyQuestion: 'question40',
    },
    {
        name: 'NGO’s grants',
        value: 'Item 6',
        keyQuestion: 'question45',
    },
    {
        name: 'Public subsidies',
        value: 'Item 7',
        keyQuestion: 'question50',
    },
    {
        name: 'Public grants',
        value: 'Item 8',
        keyQuestion: 'question55',
    },
    {
        name: 'Venture capital',
        value: 'Item 9',
        keyQuestion: 'question60',
    },
    {
        name: 'Microfinance',
        value: 'Item 10',
        keyQuestion: 'question65',
    },
    {
        name: 'Financial institutions (banks)',
        value: 'Item 11',
        keyQuestion: 'question70',
    },
    {
        name: 'Other',
        value: 'other',
        keyQuestion: 'question75',
    },
];

const series = [
    {
        name: 'Issues related to the business model',
        value: 'Item 1'
    },
    {
        name: 'The requested amount was too high',
        value: 'Item 2'
    },
    {
        name: 'The skills of the team were not strong enough',
        value: 'Item 3'
    },
    {
        name: 'I don\'t know',
        value: 'Item 4'
    },
    {
        name: 'Other',
        value: 'other'
    },
];

/**
 * Survey: PROJECT- FINAL IMPACT
 * question: What are the main factors that helped you obtain the funds?
 * 
 * == final
 * question19
 * question24
 * question29
 * question35
 * question40
 * question45
 * question50
 * question55
 * question60
 * question65
 * question70
 * question75
 * 
 * @param props 
 */
export const mainSuccessFactorsChartCalculation = (props: any) => {
    const calculateData = (value: string) => {
        return transformData.map(({name, keyQuestion}) => {
            const filteredSubmission = props.baselineSubmissions.filter((submission: any) => submission[keyQuestion] === value);

            return {
                name,
                y:  filteredSubmission.length / props.baselineSubmissions.length * 100,
            }
        });
    }         

    return {
        chart: {
            type: 'bar',
        },
        xAxis: {
            categories: transformData.map(({ name }) => name),
        },
        yAxis: {
            min: 0,
            max: 100,
            labels: {
              format: '{value}%'
            },
        },
        plotOptions: {
            bar: {
                dataLabels: {
                    enabled: false,
                },
                groupPadding: 0.1,
            },
        },
        title: {
            text: 'KPI: Main success factors',
            align: 'left',
        },
        series: series.map(series => ({
            showInLegend: true,
            name: series.name,
            type: 'column',
            data: calculateData(series.value),
        })),
    } as Highcharts.Options;
}